import script from "./PolicyProvisionModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PolicyProvisionModal.vue?vue&type=script&setup=true&lang=js"

import "./PolicyProvisionModal.vue?vue&type=style&index=0&id=4aacbdab&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4aacbdab"]])

export default __exports__